var r=function(r){return r};export{r as i};
